module.exports = __webpack_public_path__ + "static/media/add-debit-card.7fbcc493.jpg";